export default __webpack_public_path__ + "static/media/D2008_10_12_Sokolka.1a80b789.jpg";